import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function FeaturedCategories() {
  const { t } = useTranslation();

  const featured = [
    {
      nameKey: "category.shoes",
      url: categories[0].url,
      img: "https://readdy.ai/api/search-image?query=Clean%20white%20minimalist%20sneakers%20on%20warm%20cream%20background%2C%20editorial%20product%20photography%2C%20soft%20natural%20lighting%2C%20elegant%20composition%2C%20high%20detail%2C%20neutral%20warm%20tones%2C%20professional%20fashion%20catalog%20look%2C%20subtle%20shadows%2C%20clean%20uncluttered%20styling&width=800&height=1000&seq=feat-shoes-v2&orientation=portrait",
      tall: true,
    },
    {
      nameKey: "category.hoodies",
      url: categories[1].url,
      img: "https://readdy.ai/api/search-image?query=Premium%20hoodie%20sweater%20flatlay%20on%20light%20warm%20beige%20surface%2C%20minimalist%20editorial%20photography%2C%20soft%20diffused%20lighting%2C%20elegant%20fabric%20texture%2C%20clean%20composition%2C%20neutral%20earth%20tones%2C%20professional%20fashion%20look&width=800&height=480&seq=feat-hoodies-v2&orientation=landscape",
      tall: false,
    },
    {
      nameKey: "category.tshirts",
      url: categories[2].url,
      img: "https://readdy.ai/api/search-image?query=Designer%20t-shirt%20and%20lightweight%20jacket%20flatlay%20on%20warm%20cream%20background%2C%20editorial%20product%20photography%2C%20soft%20natural%20light%2C%20elegant%20minimalist%20composition%2C%20neutral%20warm%20tones%2C%20high%20detail%20fabric%20texture%2C%20professional%20catalog%20aesthetic&width=800&height=480&seq=feat-tshirts-v2&orientation=landscape",
      tall: false,
    },
  ];

  return (
    <section className="bg-background-50">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            {t("featured.title")}
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            {t("featured.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          <a
            href={featured[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="md:row-span-2 relative group overflow-hidden rounded-lg cursor-pointer"
          >
            <img
              src={featured[0].img}
              alt={t(featured[0].nameKey)}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-5 md:p-6">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold whitespace-nowrap">
                {t(featured[0].nameKey)}
              </span>
            </div>
          </a>

          <a
            href={featured[1].url}
            target="_blank"
            rel="noopener nofollow"
            className="relative group overflow-hidden rounded-lg cursor-pointer"
          >
            <img
              src={featured[1].img}
              alt={t(featured[1].nameKey)}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-5 md:p-6">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold whitespace-nowrap">
                {t(featured[1].nameKey)}
              </span>
            </div>
          </a>

          <a
            href={featured[2].url}
            target="_blank"
            rel="noopener nofollow"
            className="relative group overflow-hidden rounded-lg cursor-pointer"
          >
            <img
              src={featured[2].img}
              alt={t(featured[2].nameKey)}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-5 md:p-6">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold whitespace-nowrap">
                {t(featured[2].nameKey)}
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}